import { Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ButtonsFilterProps {
    selected: string,
    setSelected: (value: string) => void;
}
const ButtonsFilter = (props: ButtonsFilterProps) => {

    const { selected, setSelected } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const { t } = useTranslation();

    const handleSelect = (value: string) => {
        setSelected(value);
    };

    // Definindo estilos diretamente no componente
    const buttonStyle = useMemo(() => {
        return {
            border: '2px solid black',
            borderRadius: 0,
            width: isMobile ? '75px' : '90px',
            height: isMobile ? '40px' : '50px',
            fontSize: isMobile ? 11.5 : 20,
            fontWeight: 'bold',
            backgroundColor: 'transparent',
            color: 'black',
            margin: isMobile ? '3px' : undefined,
            marginRight: isMobile ? undefined : '15px',
        };
    }, [isMobile])

    const selectedStyle = {
        backgroundColor: 'black',
        color: 'white',
    };

    return (
        <ButtonGroup variant="outlined" >
            <Button
                style={selected === t('TODOS') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
                onClick={() => handleSelect('TODOS')}
            >
                {t('TODOS')}
            </Button>
            <Button
                style={selected === t('TRANSFER') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
                onClick={() => handleSelect('TRANSFER')}
            >
                {t('TRANSFER')}
            </Button>
            <Button
                style={selected === t('DOWNWIND') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
                onClick={() => handleSelect('DOWNWIND')}
            >
                {t('DOWNWIND')}
            </Button>
            <Button
                style={selected === t('REPARO') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
                onClick={() => handleSelect('REPARO')}
            >
                {t('REPARO')}
            </Button>
        </ButtonGroup>
    );
};

export default ButtonsFilter;
